import React from 'react';
import { findImage } from 'utils/Utils';
import { Scheme } from 'app/pages/Payment/data';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';

export interface PaymentProps {
  GlobalData: Scheme[];
  isGlobal: boolean;
  selectedScheme: Scheme;
  setSelectedScheme: (method: Scheme) => void;
  setSelectedPayment: (
    type: 'credit' | 'apm' | 'bank' | 'global' | undefined,
  ) => void;
  setLoading: (method: boolean) => void;
  handleClosed: (e) => void;
  setPopup: (e: Window | null) => void;
}

const TabGlobal = ({
  GlobalData,
  isGlobal,
  selectedScheme,
  setSelectedScheme,
  setSelectedPayment,
}: PaymentProps) => {
  const handleClickGlobalPayment = item => {
    setSelectedPayment('global');
    setSelectedScheme(item);
  };

  return (
    <>
      {isGlobal && GlobalData && (
        <GlobalButtonWrapper isMobile={isMobile}>
          {GlobalData.slice()
            .reverse()
            .map((item, idx) => {
              const imgWidth =
                item.schemeCd === 'APPLEPAY-GLOBAL' ? '50' : '80';
              const isEven = GlobalData.length % 2 === 0;
              return (
                <ButtonWrapper
                  bgColor={'white'}
                  isMobile={isMobile}
                  key={idx}
                  isEven={isEven}
                >
                  <button
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8,
                      padding: '12px 16px',
                      border:
                        selectedScheme.schemeCd === item.schemeCd
                          ? '4px solid #ff7f00'
                          : '1px solid #ccc',
                      cursor: 'pointer',
                      height: 56,
                    }}
                    onClick={() => handleClickGlobalPayment(item)}
                  >
                    <img
                      src={findImage(`schemeList/GO/${item.schemeCd}.png`)}
                      width={imgWidth}
                    />
                  </button>
                </ButtonWrapper>
              );
            })}
        </GlobalButtonWrapper>
      )}
    </>
  );
};

export default TabGlobal;

const GlobalButtonWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  padding-left: ${props => (props.isMobile ? '10px' : '20px')};
  padding-right: ${props => (props.isMobile ? '10px' : '20px')};
  padding-top: 10px;
  padding-bottom: 10px;
  gap: 5px;
  background-color: #efefef;
`;

const ButtonWrapper = styled.div<{
  bgColor: string;
  isMobile: boolean;
  isEven: boolean;
}>`
  box-sizing: border-box;
  width: ${props => (props.isEven ? '50%' : '100%')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  span {
    color: #757575;
    font-size: 16px;
  }
  button {
    width: 100%;
    height: 50px;
    border-radius: 4px;
    border: 1px solid #bdbdbd;
    color: white;
    background-color: ${props => props.bgColor};
  }
`;
